import { c as _c } from "react/compiler-runtime";
import { ComponentSectionsOpenJobs, Job, JobEntity } from "@lib/generated/graphql";
import useLanguage from "@lib/hooks/useLanguage";
import getJobsData from "@lib/strapi/getJobsData";
import { FC, useEffect, useState } from "react";
import OpenJobsComponent from "./OpenJobsComponent";
const jobsMapper = (data: JobEntity[]) => {
  return data?.map(item => item.attributes as Job);
};
type OpenJobsProps = {
  data: ComponentSectionsOpenJobs;
};
const OpenJobs: FC<OpenJobsProps> = t0 => {
  const $ = _c(7);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [jobs, setJobs] = useState(t1);
  const locale = useLanguage();
  let t2;
  let t3;
  if ($[1] !== locale) {
    t2 = () => {
      getJobsData({
        locale,
        publicationState: "LIVE"
      }).then(data_0 => {
        if (data_0) {
          setJobs(jobsMapper(data_0));
        }
      });
    };
    t3 = [locale];
    $[1] = locale;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== data || $[5] !== jobs) {
    t4 = <OpenJobsComponent data={data} jobs={jobs} />;
    $[4] = data;
    $[5] = jobs;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default OpenJobs;